module.exports = __webpack_public_path__ + "media/audio36.5647b05e.mp3";